import StoreHelper from '../store/helper'

import _ from 'lodash'
import DomHelper from './DomHelper'

class PaginationHelper {
  static getItemsByPage (items, page) {
    const start = this._calculateStartIndex(page)
    const end = this._calculateEndIndex(start)

    return _.slice(items, start, end)
  }

  static isInCurrentPageRange (index) {
    const start = this._calculateStartIndex(StoreHelper.getPaginationPage())
    const end = this._calculateEndIndex(start)

    return !StoreHelper.isPaginationEnabled() || _.inRange(index, start, end)
  }

  static _calculateStartIndex (page) {
    return page * StoreHelper.getMaxItemsPerPage()
  }

  static _calculateEndIndex (start) {
    return start + StoreHelper.getMaxItemsPerPage()
  }

  static redefineElementsVisibility (elements) {
    elements.forEach((el, index) => {
      this.isInCurrentPageRange(index) ? DomHelper.displayElement(el) : DomHelper.hideElement(el)
    })
  }
}

export default PaginationHelper
